import React, { FC } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import useMobileNativeWebView from 'src/common/hooks/useMobileNativeWebView';
import styles from './NoResults.module.scss';

import { NEW_TAB_ATTRIBUTES, PATHS, SUPPORT_URLS } from '../../../common/constants';
import Icon from '../../../common/components/Icon';
import UniversalLink from '../../../common/components/UniversalLink';

const NoResults: FC = () => {
  const [t] = useTranslation('search-page');
  const { isMobileNativeWebView } = useMobileNativeWebView();

  return (
    <div className={styles.root}>
      <Icon
        id="search/empty-search"
        className={styles.image}
      />
      <h4 className={styles.heading}>{t('no-results--heading')}</h4>
      <h5 className={styles.heading}>
        <Trans
          t={t}
          i18nKey="no-results--subheading"
          components={{ bold: <strong /> }}
        />
      </h5>
      {!isMobileNativeWebView && (
        <div className={styles.description}>
          <p>
            <Trans
              t={t}
              i18nKey="no-results--para-1"
              components={{
                a: (
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                  <a
                    href={SUPPORT_URLS.REQUEST}
                    className={styles.link}
                    {...NEW_TAB_ATTRIBUTES}
                  />
                ),
              }}
            />
          </p>
          <p>
            <Trans
              t={t}
              i18nKey="no-results--para-2"
              components={{
                a: (
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                  <UniversalLink
                    href={PATHS.ADMIN_LISTINGS}
                    className={styles.link}
                  />
                ),
              }}
            />
          </p>
        </div>
      )}
    </div>
  );
};

export default NoResults;
